// Stop the type system complaining about redux devtools,
// which is attached to the Window by chrome/ff extension "redux-devtools".
import { ROUTER_BASENAME } from "../constants";
import { links } from "../utils";

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: any;
    Cypress: any;
    store: any;
  }
}

export interface NavLinkProps {
  to: string;
  children: React.ReactNode;
}

export enum HTTPMethod {
  GET = "GET",
  PUT = "PUT",
  POST = "POST",
  HEAD = "HEAD",
  DELETE = "DELETE",
}

export interface ApexApiError extends Error {
  response?: Response;
  status?: number;
}

export interface menuItem {
  headerText: string;
  parentHeader: string;
  urlText: string;
  webLinkId: string;
}

const getActiveLink = (indices: number[], link: NavLinkProps, i: number) => {
  // Spread to avoid mutating param.
  const idxs = [...indices];
  const location =
    typeof window !== "undefined" ? window.location.pathname : "/";
  if (location === `/${ROUTER_BASENAME}${link.to}`) {
    idxs.push(i);
  }
  return idxs;
};

export const isActiveLink = (index: number) =>
  index === links.reduce(getActiveLink, []).shift();

export * from "./StateTypes";
export * from "./Trades";
